// Add project specific javascript code and import of additional bundles here:

import {fieldRegistry} from "sulu-admin-bundle/containers";

import EducationList from "./fields/EducationList";

fieldRegistry.add("education_list", EducationList);
